<template>
    <form class="main-filter" >
            <div class="main-filter__inputs">
                <div class="main-filter__input-wrap main-filter__input-wrap--search  col-lg-4 col-xl-2 ">
                    <multiselect

                            v-model="typeValues"
                            :options="types"
                            placeholder="Тип объекта"
                            :multiple="true"
                            selectLabel=""
                            selectedLabel=""
                            deselectLabel=""
                            track-by="value"
                            :close-on-select="false"
                            @select=onSelectType
                            @remove=onRemoveType
                    >
                      <template slot="option" slot-scope="props" >
                         <span class="multiselect__checkbox-label">
                            <input class="multiselect__checkbox-input" type="checkbox" v-model="props.option.checked" @focus.prevent/>
                            <span class="multiselect__checkbox-checkmark "></span>
                              {{props.option.value }}
                          </span>
                      </template>
                      <template slot="tag">{{''}}</template>

                      <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <div class="multiselect__container multiselect__single"  v-if="values.length &amp;&amp; !isOpen">
                           <span class="multiselect__placeholder">
                           Тип объекта
                        </span>
                        </div>
                      </template>
                        <span slot="noOptions" class="multiselect__helper">
                            Нет данных
                        </span>
                        <span slot="noResult" class="multiselect__helper">Не найдено</span>
                    </multiselect>
                  <div class="main-filter__input-alert" v-if="typeValues.length > 0" @click.prevent="clearSelect('type')">
                    <span class="main-filter__input-alert-text">
                    {{num_word(typeValues.length, words_1)}} {{typeValues.length}} {{num_word(typeValues.length, words)}}
                    </span>
                    <div class="main-filter__input-alert-close-wrap">
                      <svg viewBox="0 0 10 10" class="main-filter__input-alert-close" >
                        <use xlink:href="/assets/site/images/sprites.svg?ver=41#sprite-close"></use>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="main-filter__input-wrap col-lg-4  col-xl-2">

                    <multiselect

                            v-model="floorValues"
                            :options="floors"
                            track-by="value"
                            :close-on-select="false"
                            placeholder="Этаж"
                            :multiple="true"
                            selectLabel=""
                            selectedLabel=""
                            deselectLabel=""
                            @select=onSelectFloor
                            @remove=onRemoveFloor
                    >
                      <template slot="option" slot-scope="props" >
                         <span class="multiselect__checkbox-label">
                            <input class="multiselect__checkbox-input" type="checkbox" v-model="props.option.checked" @focus.prevent/>
                            <span class="multiselect__checkbox-checkmark "></span>
                              {{props.option.value }}
                          </span>
                      </template>
                      <template slot="tag">{{''}}</template>

                      <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <div class="multiselect__container multiselect__single"  v-if="values.length &amp;&amp; !isOpen">
                           <span class="multiselect__placeholder">
                           Этаж
                        </span>
                        </div>
                      </template>
                        <span slot="noOptions" class="multiselect__helper">
                            Нет данных
                        </span>
                        <span slot="noResult" class="multiselect__helper">Не найдено</span>
                    </multiselect>
                  <div class="main-filter__input-alert" v-if="floorValues.length > 0" @click.prevent="clearSelect('floor')">
                    <span class="main-filter__input-alert-text">
                    {{num_word(floorValues.length, words_1)}} {{floorValues.length}} {{num_word(floorValues.length, words)}}
                    </span>
                    <div class="main-filter__input-alert-close-wrap">
                      <svg viewBox="0 0 10 10" class="main-filter__input-alert-close" >
                        <use xlink:href="/assets/site/images/sprites.svg?ver=41#sprite-close"></use>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="main-filter__input-wrap col-lg-4  col-xl-2">

                    <multiselect
                            v-model="roomValues"
                            :options="rooms"
                            track-by="value"
                            :close-on-select="false"
                            placeholder="Кол-во комнат"
                            :multiple="true"
                            selectLabel=""
                            selectedLabel=""
                            deselectLabel=""
                            @select=onSelectRoom
                            @remove=onRemoveRoom
                    >
                      <template slot="option" slot-scope="props" >
                     <span class="multiselect__checkbox-label">
                        <input class="multiselect__checkbox-input" type="checkbox" v-model="props.option.checked" @focus.prevent/>
                        <span class="multiselect__checkbox-checkmark "></span>
                          {{props.option.value }}
                      </span>
                      </template>
                      <template slot="tag">{{''}}</template>
                      <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <div class="multiselect__container multiselect__single"  v-if="values.length &amp;&amp; !isOpen">
                           <span class="multiselect__placeholder">
                         Кол-во комнат
                        </span>
                        </div>
                      </template>
                        <span slot="noOptions" class="multiselect__helper">
                            Нет данных
                        </span>
                        <span slot="noResult" class="multiselect__helper">Не найдено</span>
                    </multiselect>
                  <div class="main-filter__input-alert" v-if="roomValues.length > 0" @click.prevent="clearSelect('room')">
                    <span class="main-filter__input-alert-text">
                    {{num_word(roomValues.length, words_1)}} {{roomValues.length}} {{num_word(roomValues.length, words)}}
                    </span>
                    <div class="main-filter__input-alert-close-wrap">
                      <svg viewBox="0 0 10 10" class="main-filter__input-alert-close" >
                        <use xlink:href="/assets/site/images/sprites.svg?ver=41#sprite-close"></use>
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="main-filter__input-wrap col-lg-4  col-xl-2">

                    <multiselect
                        v-model="districtValues"
                        :options="districts"
                        track-by="value"
                        placeholder="Район"
                        :multiple="true"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        :close-on-select="false"
                        @select=onSelectDistrict
                        @remove=onRemoveDistrict
                    >
                      <template slot="option" slot-scope="props" >
                      <span class="multiselect__checkbox-label">
                        <input class="multiselect__checkbox-input" type="checkbox" v-model="props.option.checked" @focus.prevent/>
                        <span class="multiselect__checkbox-checkmark "></span>
                          {{props.option.value }}
                      </span>
                      </template>
                      <template slot="tag">{{''}}</template>
                      <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <div class="multiselect__container multiselect__single"  v-if="values.length &amp;&amp; !isOpen">
                         <span class="multiselect__placeholder">
                            Район
                        </span>
                        </div>
                      </template>
                        <span slot="noOptions" class="multiselect__helper">
                            Нет данных
                        </span>
                        <span slot="noResult" class="multiselect__helper">Не найдено</span>
                    </multiselect>
                  <div class="main-filter__input-alert" v-if="districtValues.length > 0" @click.prevent="clearSelect('district')">
                    <span class="main-filter__input-alert-text">
                      {{num_word(districtValues.length, words_1)}} {{districtValues.length}} {{num_word(districtValues.length, words)}}
                    </span>
                    <div class="main-filter__input-alert-close-wrap">
                      <svg viewBox="0 0 10 10" class="main-filter__input-alert-close" >
                        <use xlink:href="/assets/site/images/sprites.svg?ver=41#sprite-close"></use>
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="main-filter__input-wrap col-lg-4  col-xl-2">
                    <div class="main-filter__input-group">
                      <label class="main-filter__input-group-flex main-filter__input-group-flex--first" >
                        <number-input :placeholder="'Площадь от'"
                                      v-model.number="filterForm.square_from"
                                      v-on:keyup.enter="search"></number-input>
                      </label>
                      <label  class="main-filter__input-group-flex main-filter__input-group-flex--last">
                        <number-input placeholder="до"
                                      v-model="filterForm.square_to"
                                      v-on:keyup.enter="search"></number-input>
                      </label>

                       <span class="main-filter__input-group-text">
                        м²
                      </span>

                    </div>
                </div>
                <div class="main-filter__input-wrap col-lg-4  col-xl-2">
                    <div class="main-filter__input-group">
                      <label  class="main-filter__input-group-flex main-filter__input-group-flex--first main-filter__input-group-flex--first-price" >
                        <number-input placeholder="Цена от"
                                      v-model="filterForm.apartment_price_from"
                                      v-on:keyup.enter="search"></number-input>
                      </label>

                      <label  class="main-filter__input-group-flex main-filter__input-group-flex--last main-filter__input-group-flex--last-price" >
                        <number-input placeholder="до"
                                      v-model="filterForm.apartment_price_to"
                                      v-on:keyup.enter="search"></number-input>
                      </label>
                        <span class="main-filter__input-group-text">
                           руб.
                        </span>
                    </div>
                </div>
            </div>
            <div class="main-filter__btns">
                <button class="btn button button--big button-white-transparent main-filter__map-btn" @click.prevent="showOnMap">

                    Показать на карте
                </button>
                <button type="submit" class="btn button button--big button-red main-filter__search-btn" @click.prevent="">Найти</button>
            </div>
    </form>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import NumberInput from '../common/number-input'
    export default {
        components: { Multiselect, NumberInput},

        data() {
            return {

                filterForm: {
                    name:'',
                    square_from:'',
                    square_to:'',
                    apartment_price_from:'',
                    apartment_price_to:'',
                    rooms: [],
                    districts:[],
                    floors:[],
                    type:[],

                },
              words:['элемент', 'элемента', 'элементов'],
              words_1:['Выбран', 'Выбрано', 'Выбрано'],
              floorValues:[],
              typeValues:[],
              roomValues:[],
              districtValues:[],
                types:['Вторичка', 'От застройщика'],
                rooms: [1,2,3,4,5],
                districts:[],
                floors: [1,2,3,4,5,6,7,8,9,10,11,12],
              priceFocus:false,
              squareFocus:false

            }
        },
        methods: {
          priceToggle(val) {
            this.priceFocus = val;
          },
          squareToggle(val) {
            this.squareFocus = val;
          },
          num_word(value, words){
            value = Math.abs(value) % 100;
            var num = value % 10;
            if(value > 10 && value < 20) return words[2];
            if(num > 1 && num < 5) return words[1];
            if(num == 1) return words[0];
            return words[2];
          },
          clearSelect(type) {
            if(type === 'district') {
              this.districtValues =[];
              this.districts.forEach(function (item){
                item.checked = false;
              })
            }
            if(type === 'floor') {
              this.floorValues =[];
              this.floors.forEach(function (item){
                item.checked = false;
              })
            }
            if(type === 'room') {
              this.roomValues =[];
              this.rooms.forEach(function (item){
                item.checked = false;
              })
            }
            if(type === 'type') {
              this.typeValues =[];
              this.types.forEach(function (item){
                item.checked = false;
              })
            }

          },
            search() {
               // this.$refs.rooms.value = this.filterForm.rooms;
             // window.location= '/buildings'
              this.filterForm.rooms = this.roomValues.map(function (item){
                return item.value;
              });
              this.filterForm.types = this.typeValues.map(function (item){
                return item.value;
              });
              this.filterForm.districts = this.districtValues.map(function (item){
                return item.value;
              });
              this.filterForm.floors = this.floorValues.map(function (item){
                return item.value;
              });
                if(this.filterForm.name || this.filterForm.rooms.length > 0 || this.filterForm.districts.length > 0 ||  this.filterForm.floors.length > 0 || this.filterForm.apartment_price_from || this.filterForm.apartment_price_to || this.filterForm.square_from || this.filterForm.square_to) {
                    axios.post('/api/building/search',this.filterForm)
                        .then((response) => {
                            window.location.href = response.data;
                        })
                }

            //this.$refs.filterForm.submit()
            },
            getDistricts() {
                axios.get('/api/districts')
                    .then((response) => {
                      this.districts = response.data.map(function (item){
                        return {value:item, checked:false}
                      });
                    })
            },
            showOnMap() {

                    axios.post('/flats-on-map', this.filterForm)
                        .then((response) => {
                            window.location.href = response.data;
                        })
            },
          onSelectFloor (option) {
            let index = this.floors.findIndex(item => item.value==option.value);
            this.floors[index].checked = true;
          },

          onRemoveFloor (option) {
            let index = this.floors.findIndex(item => item.value==option.value);
            this.floors[index].checked = false;

          },
          onSelectType (option) {
            let index = this.types.findIndex(item => item.value==option.value);
            this.types[index].checked = true;
          },

          onRemoveType (option) {
            let index = this.types.findIndex(item => item.value==option.value);
            this.types[index].checked = false;

          },
          onSelectRoom (option) {
            let index = this.rooms.findIndex(item => item.value==option.value);
            this.rooms[index].checked = true;
          },

          onRemoveRoom (option) {
            let index = this.rooms.findIndex(item => item.value==option.value);
            this.rooms[index].checked = false;

          },
          onSelectDistrict (option) {
            let index = this.districts.findIndex(item => item.value==option.value);
            this.districts[index].checked = true;
          },

          onRemoveDistrict (option) {
            let index = this.districts.findIndex(item => item.value==option.value);
            this.districts[index].checked = false;

          },
        },
        mounted() {
            this.getDistricts();
          this.floors = this.floors.map(function (item){
            return {value:item, checked:false}
          });
          this.rooms = this.rooms.map(function (item){
            return {value:item, checked:false}
          });
          this.types = this.types.map(function (item){
            return {value:item, checked:false}
          });
        }
    }
</script>

